import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import {UfError} from '@shared/objects/uf-error'; // don't forget the imports

@Injectable({
  providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {
  private toastrService = inject(ToastrService);


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 0) {
          this.toastrService.error('Server kon niet worden gevonden.', 'Verbindingsfout');
        } else if (err.status === 403) {
          // ignore 403 errors
        } else if (err.error && err.error['@class'] === 'ErrorsDto') {
          const ufError = <UfError> err.error;
          ufError.errors.forEach(value => {
            this.toastrService.error(value.message + ` (${value.code})`, 'Fout');
          });
        } else if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', err.error.message);
          this.toastrService.error(err.error.message, 'Error');
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(`Backend returned code ${err.status}, body was: ${err.error}`);
          this.toastrService.error(`Status code: ${err.status}`, 'Server fout');
        }

        // Rethrow, do not resend. This used to be `next.handle(request)`, which executes the
        // request a second time: a POST that fails and then succeeds on the repeat is processed
        // twice — a duplicate invoice, a second mail — and the caller sees the result of attempt
        // two, so the original failure disappears without a trace. An interceptor that reports
        // errors must pass them on, not silently retry them.
        return throwError(() => err);
      })
    );

  }
}
